export const ONE_SECOND = 1_000;
export const SECONDS_PER_MINUTE = 60;
export const MINUTES_PER_HOUR = 60;
export const HOURS_PER_DAY = 24;
export const DAYS_PER_YEAR = 365;
export const ONE_MINUTE = ONE_SECOND * SECONDS_PER_MINUTE;
export const ONE_HOUR = ONE_MINUTE * MINUTES_PER_HOUR;
export const ONE_DAY = ONE_HOUR * HOURS_PER_DAY;
export const ONE_YEAR = ONE_DAY * DAYS_PER_YEAR;

// setTimeout fires immediately when the delay exceeds a signed 32-bit integer
export const MAX_TIMEOUT_DELAY = 2_147_483_647;
